import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

import { AppVariables } from '../../app.variables';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  mobileNavOpen = false;
  langOpen = false;
  environmentName = AppVariables.environmentName;
  showEnvironmentBadge = AppVariables.environmentName !== 'PROD';

  constructor(
    public router: Router
  ) { }


  isPolicyPage(): boolean {
    return this.router.url === '/polityka-prywatnosci';
  }

  isConfirmationPage(): boolean {
    return this.router.url.startsWith('/confirm-email');
  }


  toggleMobileNav(): void {
    this.mobileNavOpen = !this.mobileNavOpen;
  }

  toggleLang(): void {
    this.langOpen = !this.langOpen;
  }

  scrollTo(id: string, event: Event) {
    if (event) {
      event.preventDefault();
    }

    const element = document.getElementById(id);
    if (element) {
      const yOffset = id === 'juno' ? -200 : -100;
      const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent): void {
    if ((event.target as Window).innerWidth > 768) {
      this.mobileNavOpen = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const clickedInside = (event.target as HTMLElement).closest('app-header');
    if (!clickedInside) {
      this.mobileNavOpen = false;
      this.langOpen = false;
    }
  }
}
